export default function (state = [], action) {
  switch (action.type) {
    case "SELECT_FIELDS":
      return action.payload;
      break;
    default:
      return state;
  }
}
